import React from "react";
// import Nav from "./Nav";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import ViewListIcon from '@material-ui/icons/ViewList';
import EventNoteIcon from '@material-ui/icons/EventNote';
import {updateUrl} from '../store/actions/main';

const Header = (props) => {

    const showMenu = () => {
        let flyout_menu = document.querySelector('.flyout_menu');
        flyout_menu.classList.toggle('active');
    }

    const selectMenu = (ev) => {
        ev.stopPropagation();

        let flyout_menu = document.querySelector('.flyout_menu');
        flyout_menu.classList.remove('active');
    }

    const menu_items = [
        {link: '/', titel: 'Auswahl'},
        {link: '/zaune', titel: 'Zäune'},
        {link: '/tore', titel: 'Tore'},
        {link: '/pforten', titel: 'Pforten'},
        {link: '/stahltreppe', titel: 'Stahltreppe'},
        {link: '/gelaender', titel: 'Geländer'},
        {link: '/vordaecher', titel: 'Vordächer'}
    ]

         return(
             <header>
                <div className="headerWrapper">
                        <ViewListIcon onClick={showMenu} className="auswahl-icon" />
                        <div className='menu_wrapper'>
                            <ul className="flyout_menu">
                                <span onClick={selectMenu} className="close_button">&times;</span>
                                {menu_items.map((elem, index) => (
                                     <Link onClick={selectMenu} className="link" titel={elem.titel} to={elem.link} key={index}>
                                         <li>{elem.titel}</li>
                                     </Link>
                                ))}
                            </ul>
                        </div>
                    <h1>{props.titel}</h1>
                    <Link className="link" to="/merkliste">
                        <EventNoteIcon className="merkliste-icon" />
                        {props.counter > 0 ?<div className='product_count'>{props.counter}</div>:''}
                    </Link>

                </div>
                <hr></hr>
             </header>

         )
}

const mapStateToProps = state => {
    return {
        titel: state.mainReducer.titel,
        counter: state.mainReducer.counter
    }
}

const mapStateToDispatch = dispatch => {
    return {
        updateUrl: ev => dispatch(updateUrl(ev))
    }
}

export default connect(mapStateToProps, mapStateToDispatch)(Header);